import { useState } from 'react';
import { useSuspenseQuery } from '@apollo/client/react';
import { XIcon } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AppsDocument } from 'src/graphql/actions/apps/apps.query';
import { withSuspense } from 'src/hoc';

const NoFallback = () => null;

const UnclaimedBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false);
  const {
    data: { apps },
  } = useSuspenseQuery(AppsDocument, { variables: { unclaimed: true, perPage: 0 } });

  const handleDismiss = () => setIsDismissed(true);

  if (!apps.nodesCount || isDismissed) return null;

  return (
    <Alert className="rounded-xl p-4 bg-accent-software-escrow gap-y-1.5">
      <div className="col-span-2 flex items-center justify-between">
        <Badge variant="pill" className="bg-primary text-secondary-foreground px-2 py-1 border-0 font-bold">
          New
        </Badge>
        <Button
          variant="ghost"
          size="icon"
          className="size-6 text-white hover:text-secondary-foreground"
          aria-label="Dismiss"
          onClick={handleDismiss}
        >
          <XIcon />
        </Button>
      </div>
      <AlertTitle className="text-base font-extrabold text-white">
        Every protection now lives in an application.
      </AlertTitle>
      <AlertDescription className="text-white">
        {apps.nodesCount === 1
          ? 'We’ve replaced the separate product pages and placed your protection in its own untitled application. Finish setting it up, or merge it into another that covers the same software.'
          : `We’ve replaced the separate product pages and placed each of your ${apps.nodesCount} protections in its own untitled application. Finish setting them up, and merge any that cover the same software.`}
      </AlertDescription>
    </Alert>
  );
};

export default withSuspense(UnclaimedBanner, NoFallback);
